import { Fragment } from 'react';
import { reduxForm } from 'redux-form';

// Libs
import { GridContainer, GridItem, Input } from '@formComponents';
import ContentContainer from '@libComponents/ContentContainer';
import { email, maxLength, required, textOnly } from '@libs/validationRules';

import AutocompleteBase from '@formComponents/Autocomplete';
import DatePickerBase from '@formComponents/DatePicker';
import {
    BLOODGROUP_OPTIONS,
    GENDER_OPTIONS,
    INITIALS,
    MARITAL_STATUS
} from 'employee/common';
import { FORM_NAME, LABELS } from '../../common';

const General = reduxForm({
    form: FORM_NAME, // Form name
    destroyOnUnmount: false // Preserve data
})(() => {
    return (
        <ContentContainer
            title={LABELS.general}
            AdornmentComponent={<Fragment />}
        >
            <GridContainer>
                <GridItem md={3}>
                    <AutocompleteBase
                        name='initial'
                        placeholder='Name Initial'
                        label='Initial: (Mr. /Ms. /Mrs.)'
                        validate={required}
                        required={true}
                        options={INITIALS}
                    />
                </GridItem>
                <GridItem md={3}>
                    <Input
                        name='firstname'
                        placeholder='First Name'
                        label='First Name (In English)'
                        validate={[required]}
                        required={true}
                    />
                </GridItem>
                <GridItem md={3}>
                    <Input
                        name='middlename'
                        placeholder='Middle Name'
                        label='Middle Name (In English)'
                    />
                </GridItem>
                <GridItem md={3}>
                    <Input
                        name='lastname'
                        placeholder='Last Name'
                        label='Last Name (In English)'
                    />
                </GridItem>
                <GridItem md={3}>
                    <Input
                        name='nameInBengali'
                        placeholder='Bangla Name'
                        label='Name (In Bengali)'
                        validate={[required]}
                        required={true}
                    />
                </GridItem>
                <GridItem md={3}>
                    <AutocompleteBase
                        name='gender'
                        placeholder='Select Gender'
                        label='Gender'
                        required={true}
                        validate={required}
                        options={GENDER_OPTIONS}
                    />
                </GridItem>
                <GridItem md={3}>
                    <AutocompleteBase
                        name='bloodGroup'
                        placeholder='Select Blood Group '
                        label='Blood Group'
                        options={BLOODGROUP_OPTIONS}
                    />
                </GridItem>
                <GridItem md={3}>
                    <DatePickerBase
                        name='dateOfBirth'
                        placeholder='Select Date of Birth'
                        label='Date of Birth'
                        minDate='1900-01-01'
                        required={true}
                        validate={required}
                    />
                </GridItem>
                <GridItem md={3}>
                    <Input name='placeOfBirth' label='Place of Birth' />
                </GridItem>
                <GridItem md={3}>
                    <Input
                        name='religion'
                        placeholder='Religion'
                        label='Religion'
                        required={true}
                        validate={required}
                    />
                </GridItem>
                <GridItem md={3}>
                    <AutocompleteBase
                        name='maritalStatus'
                        placeholder='Select Marital Status'
                        label='Marital Status'
                        required={true}
                        validate={required}
                        options={MARITAL_STATUS}
                    />
                </GridItem>
                <GridItem md={4}>
                    <Input
                        name='fatherNameInEng'
                        placeholder='English Name'
                        label='Father Name (In English)'
                    />
                </GridItem>
                <GridItem md={4}>
                    <Input
                        name='fatherNameInBn'
                        placeholder='Bangla Name'
                        label='Father Name (In Bengali)'
                    />
                </GridItem>
                <GridItem md={4}>
                    <Input name='fatherOccupation' label='Father Occupation' />
                </GridItem>
                <GridItem md={4}>
                    <Input
                        name='motherNameInEng'
                        placeholder='English Name'
                        label='Mother Name (In English)'
                    />
                </GridItem>
                <GridItem md={4}>
                    <Input
                        name='motherNameInBn'
                        placeholder='Bangla Name'
                        label='Mother Name (In Bengali)'
                    />
                </GridItem>
                <GridItem md={4}>
                    <Input name='motherOccupation' label='Mother Occupation' />
                </GridItem>
            </GridContainer>
        </ContentContainer>
    );
});

export default General;
